import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
    return (
        <footer className="bg-white">
            <div className="max-w-7xl mx-auto py-4 px-4 sm:px-6 lg:px-8">
                <p className="text-center text-sm text-gray-500">
                    © 2025 Smart City Ajmer. All Rights Reserved.
                </p>

                <div className="flex justify-center flex-wrap gap-4 mt-4 text-xs font-medium text-gray-400">
                    <Link to="/terms-and-conditions" className="hover:text-brand-primary transition-colors">Terms & Conditions</Link>
                    <Link to="/privacy-policy" className="hover:text-brand-primary transition-colors">Privacy Policy</Link>
                    <Link to="/cancellation-refund-policy" className="hover:text-brand-primary transition-colors">Cancellation & Refund Policy</Link>
                    <Link to="/contact-us" className="hover:text-brand-primary transition-colors">Contact Us</Link>
                </div>

                {/* --- ADDED THIS NEW LINE --- */}
                <p className="text-center text-xs text-gray-400 mt-4">
                    Designed By <a
                        href="https://searchisend.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-medium text-brand-primary hover:underline"
                    >
                        Search is End
                    </a> !
                </p>
                {/* --- END OF ADDITION --- */}

            </div>
        </footer>
    );
}

export default Footer;